/**************************************************
 * Nombre:       Dialogo_Solicitud
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Solicitud from "../Formularios/Formulario_Solicitud";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "./Dialogo_Politicas";
import {POLITICAS} from "../../Constantes";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {envioNotificaciones} from "../../Utilidades/envioNotificaciones";

const Dialogo_Solicitud = ({cerrar}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})
    const {Cargador, terminar, iniciarCarga, Avisos} = useCargador({logoRedondo: logo, funcionUno: cerrar})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        entidad.estado = "Nuevo"
        let dox = await guardarDoc('solicitudes', entidad)
        if (dox.res) {
            await envioNotificaciones(entidad)
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Formulario_Solicitud props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 14, px: 1}}>Al enviar los datos de este formulario aceptas nuestra
                    <span
                        onClick={() => abrir(POLITICAS[0])}
                        style={{
                            cursor: 'pointer',
                            paddingLeft: 6,
                            fontWeight: 600,
                            textDecoration: 'underline'
                        }}>politica de tratamiento de datos</span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 1}}>
                <Button
                    onClick={() => subirDatos()}
                >Enviar</Button>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Solicitud